import "./UploadPodcast.css";

import React, { useRef, useState } from "react";
import { uploadFile, uploadPodcast } from "../../../services/podcastService";

import { useLoader } from "../../../hooks/useLoader";

const UploadPodcast: React.FC = () => {
  const { showLoading } = useLoader();
  const inputRef = useRef<HTMLInputElement>(null);
  const [audioFile, setAudioFile] = useState<File | null>(null);
  const [audioURL, setAudioURL] = useState<string>("");
  const [podcastTitle, setPodcastTitle] = useState<string>("");
  const [podcastDescription, setPodcastDescription] = useState<string>("");
  const [isProPodcast, setIsProPodcast] = useState<boolean>(false);
  const [duration, setDuration] = useState<string>("");

  const handleAudioFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null;
    if (file && file.type.startsWith("audio/")) {
      setAudioFile(file);
      const url = URL.createObjectURL(file);
      setAudioURL(url);

      // Create an audio element to get the duration
      const audio = new Audio(url);
      audio.addEventListener("loadedmetadata", () => {
        const minutes = Math.floor(audio.duration / 60);
        const seconds = Math.floor(audio.duration % 60);
        setDuration(`${minutes}:${seconds.toString().padStart(2, "0")}`);
      });
    } else {
      alert("Please select a valid audio file");
    }
  };

  const handleUploadBtnClick = async () => {
    if (!audioFile) {
      alert("Please select an audio file");
      return;
    }
    try {
      showLoading(true);
      const uploadResult = await uploadFile({ file: audioFile });
      await uploadPodcast({
        title: podcastTitle,
        url: uploadResult.publicUrl,
        description: podcastDescription,
        duration: duration,
        isProPodcast,
        podcastType: isProPodcast ? "pro" : undefined,
      });
      alert("Podcast uploaded successfully!");
      setAudioFile(null);
      setAudioURL("");
      setPodcastTitle("");
      setPodcastDescription("");
      setIsProPodcast(false);
      setDuration("");
    } catch (error) {
      const message = error?.response?.data?.message;
      alert(message || "Something went wrong");
      console.log("🚀 ~ handleUploadBtnClick ~ error:", error);
    } finally {
      showLoading(false);
    }
  };

  const btnDisabled = !audioURL || !podcastTitle;

  return (
    <div>
      <h1>Upload Podcast</h1>
      <div className="upload-podcast-container">
        <input
          type="text"
          placeholder="Podcast Name"
          value={podcastTitle}
          onChange={(e) => setPodcastTitle(e.target.value)}
          style={{ marginTop: 20, padding: "8px" }}
        />

        <textarea
          placeholder="Podcast description"
          value={podcastDescription}
          onChange={(e) => setPodcastDescription(e.target.value)}
          style={{ marginTop: 20, padding: "8px", width: 300, height: 200 }}
        />

        <div style={{ marginTop: 20, marginBottom: 16 }}>
          <label>
            <input
              type="checkbox"
              checked={isProPodcast}
              onChange={() => setIsProPodcast(!isProPodcast)}
            />
            Pro Podcast
          </label>
        </div>
        <div
          style={{
            marginRight: 10,
            fontWeight: 700,
            fontFamily: "Nunito Sans",
            fontSize: 16,
            color: "#161616",
          }}
        >
          <span>File :</span>
          <span style={{ marginLeft: 10 }}>
            {audioFile?.name || "Select Audio file"}
          </span>
        </div>

        <div style={{ display: "flex", gap: 20, marginTop: 50 }}>
          <button
            className="write-story-btn"
            style={{ minWidth: 150 }}
            onClick={() => inputRef.current?.click()}
          >
            {audioFile ? "Change File" : "Select File"}
          </button>

          <button
            className="write-story-btn"
            style={{ minWidth: 150, ...(btnDisabled ? { opacity: 0.5 } : {}) }}
            onClick={handleUploadBtnClick}
            disabled={btnDisabled}
          >
            Upload
          </button>
        </div>
      </div>

      <input
        id="uploadAudioFile"
        ref={inputRef}
        type="file"
        accept="audio/*"
        style={{ display: "none" }}
        onChange={handleAudioFileSelect}
      />
    </div>
  );
};

export default UploadPodcast;
